import { tableHeaderProject } from '@/types/tableHeader';
//滚动加载延时
export const SCROLL_TIMEOUT = 1000;
//测试用头像地址
export const AVATAR_URL = 'http://u.thsi.cn/testingimgsrc/tzkt/c454c37e2ec36e84db5e294547e81c5e.jpg';
//获取阅读量的接口
export const READ_NUM = 'https://bbsclick.10jqka.com.cn/getlist';
//魔法值2
export const MAGIC_TWO = 2;
//px转化rem
export const TO_REM = 50;
//魔法值3
export const MAGIC_THREE = 3;
//魔法值4
export const MAGIC_FOUR = 4;
//scroll节流时间
export const THROTTLE_TIME = 300;
//定时器时间
export const TIMEOUT_TIME = 300;
//延时时间
export const DELAY_TIME = 200;
// ajax请求状态
export const AJAX_STATUS = {
  loading: 0,
  nomore: 1,
  end: 2,
  nodata: 3,
  noreport: 4,
};
// 月份映射
export const MONTH = {
  3: 'threeMonth',
  6: 'sixMonth',
  12: 'year',
};
//页面埋点
export const STAT = {
  follow: 'free_yanbaos_ybzy_guanzhu',
  myFollow: 'free_yanbaos_ybzy_wdgz',
  noFollow: 'free_yanbaos_ybzy_wgz',
  zxg: 'free_yanbaos_ybzy_zixuangu',
  author: 'free_yanbaos_fxszy',
  org: 'free_yanbaos_jgzy',
  industry: 'free_yanbaos_hyzy',
  stock: 'free_yanbaos_ggzy',
  rank: 'free_yanbaos_ybzy_paihang',
  homeAll: 'free_yanbaos_ybzy_quanbu',
  homeRecommend: 'free_yanbaos_ybzy',
  kline: 'free_fenshi_yanbao',
};
export const URLVER = { url_ver: 'ZENGZHANG-925' };
export const homeTitle = {
  singleRank: {
    title: '个股研报排行',
    more: true,
    select: false,
  },
  industryRank: {
    title: '行业研报排行',
    more: true,
    select: false,
  },
  mechanismRank: {
    title: '机构/分析师排行',
    more: true,
    select: false,
  },
  researchReport: {
    title: '研报',
    more: false,
    select: false,
  },
};
//研报tab
export const homeTabList = [
  {
    name: '推荐',
    isActive: true,
    stat: `${STAT.homeRecommend}.tuijian`,
    tab: 'recommend',
  },
  {
    name: '关注',
    isActive: false,
    stat: `${STAT.homeRecommend}.guanzhu`,
    tab: 'attention',
  },
  {
    name: '自选股',
    isActive: false,
    stat: `${STAT.homeRecommend}.zixuangu`,
    tab: 'self',
  },
  {
    name: '全部',
    isActive: false,
    stat: `${STAT.homeRecommend}.quanbu`,
    tab: 'all',
  },
];
//研报分析师tab
export const homePageTabList = [
  {
    name: '全部',
    isActive: true,
    id: 0,
  },
  {
    name: '买入/推荐',
    isActive: false,
    id: 1,
  },
  {
    name: '增持/谨慎推荐',
    isActive: false,
    id: 2,
  },
  {
    name: '中性',
    isActive: false,
    id: 3,
  },
  {
    name: '减持/回避',
    isActive: false,
    id: 4,
  },
  {
    name: '首次覆盖',
    isActive: false,
    id: 5,
  },
];
//研报机构tab
export const homeOrgTabList = [
  {
    name: '全部',
    isActive: true,
    id: 0,
  },
  {
    name: '明星分析师',
    isActive: false,
    id: 1,
  },
  {
    name: '买入/推荐',
    isActive: false,
    id: 2,
  },
  {
    name: '增持/谨慎推荐',
    isActive: false,
    id: 3,
  },
  {
    name: '中性',
    isActive: false,
    id: 4,
  },
  {
    name: '首次覆盖',
    isActive: false,
    id: 5,
  },
];
//我的关注tab
export const myFollowTabList = [
  {
    name: '分析师',
    isActive: true,
  },
  {
    name: '机构',
    isActive: false,
  },
  {
    name: '行业',
    isActive: false,
  },
];

export const tabItems = [
  {
    name: '分析师',
    id: 1,
  },
  {
    name: '机构',
    id: 2,
  },
  {
    name: '行业',
    id: 3,
  },
];

export const homeSingleTabList = (stat: string) => [
  {
    name: '上涨空间',
    isActive: true,
    stat: `${stat}.kongjian`,
  },
  {
    name: '研报覆盖',
    isActive: false,
    stat: `${stat}.fugai`,
  },
  {
    name: '评级上调',
    isActive: false,
    stat: `${stat}.shangtiao`,
  },
  {
    name: '评级买入',
    isActive: false,
    stat: `${stat}.mairu`,
  },
];

export const homeReportTabList = [
  {
    name: '券商金股',
    isActive: true,
    stat: `${STAT.homeRecommend}.jingu`,
  },
  {
    name: '首次覆盖',
    isActive: false,
    stat: `${STAT.homeRecommend}.shouci`,
  },
  {
    name: '每周一报',
    isActive: false,
    stat: `${STAT.homeRecommend}.yibao`,
  },
];

export const rankTabList = [
  {
    name: '个股',
    isActive: true,
    stat: `${STAT.rank}.gegu`,
  },
  {
    name: '行业',
    isActive: false,
    stat: `${STAT.rank}.hangye`,
  },
  {
    name: '分析师',
    isActive: false,
    stat: `${STAT.rank}.fenxishi`,
  },
  {
    name: '机构',
    isActive: false,
    stat: `${STAT.rank}.jigou`,
  },
  {
    name: '新财富',
    isActive: false,
    stat: `${STAT.rank}.xincaifu`,
  },
];

export const singleRankHead: tableHeaderProject[][] = [
  [
    {
      name: '股票名称',
      style: {
        width: '3.42rem',
        'text-align': 'left',
      },
      type: 'normal',
    },
    {
      name: '上涨空间',
      style: {
        width: '1.84rem',
        'text-align': 'right',
      },
      type: 'confuse',
      confuseType: 'szkj',
    },
    {
      name: '研报数',
      style: {
        width: '1.6rem',
        'text-align': 'right',
      },
      type: 'normal',
    },
  ],
  [
    {
      name: '股票名称',
      style: {
        width: '2.3rem',
        'text-align': 'left',
      },
      type: 'normal',
    },
    {
      name: '研报数',
      style: {
        width: '1.52rem',
        'text-align': 'right',
      },
      rankStatus: 1,
      rankType: '0',
      stat: 'ybs',
      type: 'rank',
    },
    {
      name: '机构数',
      style: {
        width: '1.44rem',
        'text-align': 'right',
      },
      rankStatus: 0,
      rankType: '1',
      stat: 'jgs',
      type: 'rank',
    },
    {
      name: '涨幅',
      style: {
        width: '1.6rem',
        'text-align': 'right',
      },
      rankStatus: 0,
      rankType: '2',
      type: 'rank',
      stat: 'zf',
    },
  ],
  [
    {
      name: '股票名称',
      style: {
        width: '2.22rem',
        'text-align': 'left',
      },
      type: 'normal',
    },
    {
      name: '上调家数',
      style: {
        width: '1.84rem',
        'text-align': 'right',
      },
      type: 'confuse',
      confuseType: 'stjs',
    },
    {
      name: '最新评级变化',
      style: {
        width: '2.8rem',
        'text-align': 'right',
      },
      type: 'confuse',
      confuseType: 'stpj',
    },
  ],
  [
    {
      name: '股票名称',
      style: {
        width: '50%',
        'text-align': 'left',
      },
      type: 'normal',
    },
    {
      name: '评级买入家数',
      style: {
        width: '50%',
        'text-align': 'right',
      },
      type: 'normal',
    },
  ],
];

export const industryRankHead = (name: string) => [
  {
    name: '股票名称',
    style: {
      width: '2.22rem',
      'text-align': 'left',
    },
    type: 'normal',
  },
  {
    name: '研报数',
    style: {
      width: '1.42rem',
      'text-align': 'right',
    },
    type: 'rank',
    rankStatus: 1,
    rankType: '0',
    stat: 'ybs',
  },
  {
    name,
    style: {
      width: '1.6rem',
      'text-align': 'right',
    },
    type: 'rank',
    rankStatus: 0,
    rankType: '1',
    stat: name === '涨幅' ? 'zf' : 'ybs',
  },
];

export const allReportSelect = () => [
  {
    name: '研报类型',
    isActive: false,
    isSelected: false,
    type: 'select',
    stat: `${STAT.homeAll}.yblx`,
  },
  {
    name: '行业分类',
    isActive: false,
    isSelected: false,
    type: 'button',
    stat: `${STAT.homeAll}.hyfl`,
  },
  {
    name: '机构/分析师',
    isActive: false,
    isSelected: false,
    type: 'button',
    stat: `${STAT.homeAll}.jgfxs`,
  },
  {
    name: '评级',
    isActive: false,
    isSelected: false,
    type: 'select',
    stat: `${STAT.homeAll}.pj`,
  },
];
// 用来设置情绪图表样式的数据
export const emotionChartStyle = {
  positive: {
    type: '乐观',
    color: {
      font: '#FF2436',
      bg: 'linear-gradient(181deg, rgba(255,36,54,0.10) 0%, rgba(255,255,255,0.00) 97%)',
    },
  },
  negative: {
    type: '悲观',
    color: {
      font: '#07AB4B',
      bg: 'linear-gradient(181deg, rgba(7,171,75,0.10) 0%, rgba(255,255,255,0.00) 97%)',
    },
  },
  neutral: {
    type: '中性',
    color: {
      font: '#FF9500',
      bg: 'linear-gradient(181deg, rgba(255,149,0,0.10) 0%, rgba(255,255,255,0.00) 97%)',
    },
  },
};
// 情绪图的筛选条件
export const emotionDropMenu = [
  {
    label: '近1天',
    value: '1d',
  },
  {
    label: '近1周',
    value: '1w',
  },
  {
    label: '近1月',
    value: '1m',
  },
];

export const singleRankDropMenu = [
  {
    label: '近1月',
    value: '1m',
  },
  {
    label: '近3月',
    value: '3m',
  },
  {
    label: '近半年',
    value: '6m',
  },
];

export const reportCoverDropMenu = [
  {
    label: '近1日',
    value: '1',
  },
  {
    label: '近5日',
    value: '5',
  },
  {
    label: '近20日',
    value: '20',
  },
  {
    label: '近60日',
    value: '60',
  },
];

export const reportNumDropMenu = [
  {
    label: '研报数≥3',
    value: '3',
    stat: `${STAT.rank}.saixuan.three`,
  },
  {
    label: '研报数≥5',
    value: '5',
    stat: `${STAT.rank}.saixuan.five`,
  },
  {
    label: '研报数≥10',
    value: '10',
    stat: `${STAT.rank}.saixuan.ten`,
  },
  {
    label: '研报数≥20',
    value: '20',
    stat: `${STAT.rank}.saixuan.twenty`,
  },
  {
    label: '无',
    value: '',
  },
];

export const iframeTabList = (stat: string) => [
  {
    name: '机构评级',
    isActive: true,
    stat: `${stat}.gdtj.grade`,
  },
  {
    name: '目标价格',
    isActive: false,
    stat: `${stat}.gdtj.target`,
  },
  {
    name: '净利润预测',
    isActive: false,
    stat: `${stat}.gdtj.forecast`,
  },
];

export const iframeEmotionDropMenu = [
  {
    label: '近1月',
    value: '1m',
  },
  {
    label: '近3月',
    value: '3m',
  },
  {
    label: '近半年',
    value: '6m',
  },
  {
    label: '近1年',
    value: '1y',
  },
];

export const hotDropMenu = [
  { label: '最新', value: '' },
  { label: '近24h最热', value: '1d' },
  { label: '近1周最热', value: '1w' },
  { label: '近1⽉最热', value: '1m' },
  { label: '近3⽉最热', value: '3m' },
];

export const screenGrade = [
  {
    name: '买入/推荐',
    value: '1',
  },
  {
    name: '增持/谨慎推荐',
    value: '2',
  },
  {
    name: '中性',
    value: '3',
  },
  {
    name: '减持/回避',
    value: '4',
  },
  {
    name: '卖出',
    value: '5',
  },
  {
    name: '不评级',
    value: '0',
  },
];

export const BUSINESS_CONFIG = {
  // 弹窗-0 浮窗-1 不显示2
  SHOW_TYPE: {
    IS_POPUP: 0,
    IS_FLOAT: 1,
    IS_HIDEN: 2,
  },
  // 跳转类型
  ACTION_LABEL: {
    // 弹窗
    SLIDE: 'slide',
    // 浮窗
    JUMP_URL: 'jumpUrl',
  },
  ACTION_TYPE: {
    SLIDE: 0,
    JUMP_URL: 1,
  },
  // 进入页面行为
  DEFAULT_ACTION: {
    SHOW_DEHY_REPORT: 1,
  },
};

export const SUCCESS_CODE = 0;
export const SWIPER_FIRST_INDEX = 0;
export const FUTURES_REPORT_TYPE = '008';
export const REGEX_FUTURES_CODE = /^[a-zA-Z]*9999$/;
export const FUTURES_MARKET = '65';
// 热门板块默认选中tab
export const DEFAULT_HOT_BLOCK_TAB = 'cn_concept';
// 同顺工坊工作流ID
export const AI_WORKFLOW_CONFIG = {
  HOT_BLOCK_SUMMARY: '19886',
  AI_ANALYSIS_EVENT: '19966',
  EXPLORE_REPORT_SUMMARY: '23754',
};
// AI研报要点统一接口
export const AI_CONTENT_URL = 'https://dq.10jqka.com.cn/platform/aicontent/v1/query';
// AI研报要点详情页地址
export const AI_CONTENT_DETAIL_URL =
  'https://eq.10jqka.com.cn/hxapp/kamis-renderer/index.0.4.0.html?token=K72MjEzMTUB5';
// 手炒通用分享组件全局挂载名称
export const COMMON_SHARE_NAME = 'mobileweb_CommonBridge@1.0.6';
// 手炒通用分享组件CDN
export const COMMON_SHARE_CDN =
  'https://s.thsi.cn/cd/mobileweb-eq-ths-mobile-components-front-container/mobileweb_CommonBridge@1.0.6.js';
